import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';
import { toast } from 'react-hot-toast';
const apiService =  HttpService;

// Initial state of the slice
const initialState = {
  orderData: [], // List of orders for the inbox
  suppliers: [], // List of suppliers for a company
  productData: [],
  linkingorders: [],
  linkedOrder: null,
  orderDetails: null, // Details of a single order
  productDetails: null,
  linkedOrderDetails: null,
  uomDetails: null,
  // loading: false,
  error: null,
  updateOrder: {},
  paginationInfoLinkingOrder: {},
  loading: {
    fetchOrders: false,
    createOrder: false,
    fetchOrderById: false,
    editOrder: false,
    linkedOrder: false,
    fetchSuppliersByCompanyId: false,
    fetchLinkingOrders: false,
    addProduct: false,
    fetchOrderDetails: false,
    unlinkOrder: false,
    placeOrder: false,
    cancelOrder: false,
    updateProduct: false,
    deleteOrderById: false,
    deleteOrderProduct: false,
    fetchUOMDetails: false,
    // Add more as needed...
  },
};

// Async thunk for fetching orders for the inbox
export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (queryParams, thunkAPI) => {
    try {
      const response = await apiService.get('admin/orders/',
        { params: queryParams },
      );
      console.log("response in Order: ", response)
      return response.data
    } catch (error) {
      console.log("error : ", error)

      return thunkAPI.rejectWithValue(error.response.data || error.message);
    }
  }
  // async (thunkAPI) => {
  //   try {
  //     const response = await apiService.get(`/admin/orders/`);
  //     return response.data;
  //   } catch (error) {
  //     console.log("error : ", error);

  //     return thunkAPI.rejectWithValue(error.response.data || error.message);
  //   }
  // }
);


// Async thunk for creating an order
export const createOrder = createAsyncThunk(
  'order/createOrder',
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await apiService.post('/orders', orderData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log('!!error create Order!!!', error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching an order by ID
export const fetchOrderById = createAsyncThunk(
  'order/fetchOrderById',
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/orders/${orderId}`);
      // console.log('OrderData', response.data)

      return response.data; // response
    } catch (error) {
      // console.error("Failed to fetch order details:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for adding a product to an order
export const addProduct = createAsyncThunk(
  'order/addProduct',
  async ({ orderId, orderData }, { rejectWithValue }) => {
    try {
      // console.log('!!Add Product!!!',orderId,orderData)
      const url = `/orders/${orderId}/products`;
      const response = await apiService.post(url, orderData); // Adjust the endpoint as necessary
      console.log('!!respnse Product!!!', response)
      toast.success(response.msg);
      return response; //   the API responds with the added product data
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log('!!error Product!!!', error);
      return rejectWithValue(error.response?.data); // Ensure this matches your error handling strategy
    }
  }
);

// Async thunk for get Product Details order
export const fetchOrderDetails = createAsyncThunk(
  'order/fetchOrderDetails',
  async (orderId, { rejectWithValue }) => {
    try {
      const url = `/v2/orders/${orderId}/order-product`;
      const response = await apiService.get(url);
      return response.data; //   the API responds with order details
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  });
// Async thunk for Edit a product to an order
export const updateProduct = createAsyncThunk(
  'order/updateProduct',
  async ({ orderId, orderProductId, updateProducts }, { rejectWithValue }) => {
    console.log('!!update Product!!!', orderId, orderProductId, updateProducts)
    try {
      const response = await apiService.put(`/orders/${orderId}/products/${orderProductId}`, updateProducts);
      return response.data; // Assuming the API responds with the updated product data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);


export const deleteOrderProduct = createAsyncThunk(
  'order/deleteOrderProduct',
  async ({ orderId, orderProductId }, { rejectWithValue }) => {
    try {
      const response = await apiService.delete(`/orders/${orderId}/products/${orderProductId}`);
      // Assuming the API sends back a success message in response.data.msg
      toast.success(response.msg || "Product successfully deleted.");
      return response.data; // Assuming you want to work with the data part of the response
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "Failed to delete the product.";
      toast.error(errorMessage);
      console.log('!!error Deleting Product!!!', error);
      return rejectWithValue(error.response?.data || "An unexpected error occurred");
    }
  }
);

// Async thunk for Delete a ORDER 
export const deleteOrderById = createAsyncThunk(
  'orders/deleteOrderById',
  async ({ orderId }, { rejectWithValue }) => {
    try {
      // console.log('!!DELETE ORDER!!!',orderId)      
      const response = apiService.delete(`/orders/${orderId}`);

      return response
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);


// update Order details
export const editOrder = createAsyncThunk(
  'order/editOrder',
  async ({ orderId, orderData }, { rejectWithValue }) => {
    try {
      const url = `/orders/${orderId}`;
      const response = await apiService.put(url, orderData); // put
      return response.data; //   your API returns the updated order data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// linked Order 
export const linkedOrder = createAsyncThunk(
  'order/linkedOrder',
  async ({ linkedOrderId, linkedOrderData }, { rejectWithValue }) => {
    try {
      console.warn('!!!!!Linked!!!!', linkedOrderId, linkedOrderData)

      const response = await apiService.patch(`/orders/${linkedOrderId}`, linkedOrderData);// patch
      toast.success(response.data.msg);
      return response.data; //   your API returns the updated order data
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log('!!error linked!!!', error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// unlink Order 
export const unlinkOrder = createAsyncThunk(
  'order/unlinkOrder',
  async ({ unLinkorderId, linkedOdata }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/orders/${unLinkorderId}`,
        linkedOdata
      );
      toast.success(response.data.msg);
      return response
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log('!!error unlinked!!!', error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Place Order
export const placeOrder = createAsyncThunk(
  'order/placeOrder',
  async ({ orderId, actionType }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/orders/${orderId}`, { // patch
        action: actionType
      });
      toast.success(response.data.msg);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log('!!error place!!!', error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);


// Cancel Order
export const cancelOrder = createAsyncThunk(
  'order/cancelOrder',
  async ({ orderId, cancelReason, action }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/orders/${orderId}`, {
        action,
        cancelReason
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Get Suppliers by CompanyID
export const fetchSuppliersByCompanyId = createAsyncThunk(
  'order/fetchSuppliersByCompanyId',
  async (queryParams, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.get('/orders/supplier-companies',
        // { params: queryParams },
      );
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get Linking Order Lists
export const fetchLinkingOrders = createAsyncThunk(
  'order/fetchLinkingOrders',
  async (queryParams, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.get('/orders/linking-orders',
        { params: queryParams },
      );
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// get UOM by type :
export const fetchUOMDetails = createAsyncThunk(
  'order/fetchUOMDetails',
  async ({ type }, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/orders/uom`, { params: { type } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// The order slice
export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
  reducers: {
    resetOrderState: (state) => {
      state.orderData = [];
      state.paginationInfo = {};
      state.orderDetails = null;
      state.productDetails = null;
      state.linkedOrder = null;
      // state.loading = false;
      state.error = null;
      state.updateOrder = {};
      state.paginationInfoLinkingOrder = {};
      state.loading = {
        fetchOrders: false,
        createOrder: false,
        fetchOrderById: false,
        editOrder: false,
        linkedOrder: false,
        fetchSuppliersByCompanyId: false,
        fetchLinkingOrders: false,
        addProduct: false,
        fetchOrderDetails: false,
        unlinkOrder: false,
        placeOrder: false,
        cancelOrder: false,
        updateProduct: false,
        deleteOrderById: false,
        deleteOrderProduct: false,
        fetchUOMDetails: false,
        // Add more as needed...
      }
    },
    setOrder: (state, action) => {
      state.updateOrder = action.payload;
    },
  },
  setOrder: (state, action) => {
        state.updateOrder = action.payload;
      },
  resetOrderState: (state) => {
    return { ...initialState, loading: { ...initialState.loading } };
  },
},
  extraReducers: (builder) => {
    builder
      // Handling fetchOrders
      .addCase(fetchOrders.pending, (state) => {
        state.loading.fetchOrders = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading.fetchOrders = false;
        state.orderData = action.payload.data.listData; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.data.count,
        };
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading.fetchOrders = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      // Handling createOrder
      .addCase(createOrder.pending, (state) => {
        state.loading.createOrder = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading.createOrder = false;
        // Optionally update orders list or orderDetails with the newly created order
        state.orderDetails = action.payload; //   you want to view this order next
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading.createOrder = false;
        state.error = action.payload;
      })
      // Handling fetchOrderById
      .addCase(fetchOrderById.pending, (state) => {
        state.loading.fetchOrderById = true;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.loading.fetchOrderById = false;
        state.orderDetails = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading.fetchOrderById = false;
        state.error = action.payload;
      })
      .addCase(editOrder.pending, (state) => {
        state.loading.editOrder = true;
      })
      .addCase(editOrder.fulfilled, (state, action) => {
        state.loading.editOrder = false;

        state.orderDetails = action.payload;
      })
      .addCase(editOrder.rejected, (state, action) => {
        state.loading.editOrder = false;
        state.error = action.payload;
      })
      .addCase(linkedOrder.pending, (state) => {
        state.loading.linkedOrder = true;
      })
      .addCase(linkedOrder.fulfilled, (state, action) => {
        state.loading.linkedOrder = false;

        state.linkedOrder = action.payload;
      })
      .addCase(linkedOrder.rejected, (state, action) => {
        state.loading.linkedOrder = false;
        state.error = action.payload;
      })
      // Handling fetchSuppliersByCompanyId
      .addCase(fetchSuppliersByCompanyId.pending, (state) => {
        state.loading.fetchSuppliersByCompanyId = true;
      })
      .addCase(fetchSuppliersByCompanyId.fulfilled, (state, action) => {
        state.loading.fetchSuppliersByCompanyId = false;
        state.suppliers = action.payload; //   the payload is the suppliers list
      })
      .addCase(fetchSuppliersByCompanyId.rejected, (state, action) => {
        state.loading.fetchSuppliersByCompanyId = false;
        state.error = action.payload;
      })
      // Handling fetchSuppliersByCompanyId
      .addCase(fetchLinkingOrders.pending, (state) => {
        state.loading.fetchLinkingOrders = true;
      })
      .addCase(fetchLinkingOrders.fulfilled, (state, action) => {
        state.loading.fetchLinkingOrders = false;
        state.linkingorders = action.payload;
        state.paginationInfoLinkingOrder = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchLinkingOrders.rejected, (state, action) => {
        state.loading.fetchLinkingOrders = false;
        state.error = action.payload;
      })
      //  Handling Add Product in Orders
      .addCase(addProduct.pending, (state) => {
        state.loading.addProduct = true;
        state.error = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.loading.addProduct = false;
        state.productData = action.payload.data;
        state.error = null;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.loading.addProduct = false;
        state.error = action.payload;
      })
      // Handiling fetchOrdersProdcut by OrderId
      .addCase(fetchOrderDetails.pending, (state) => {
        state.loading.fetchOrderDetails = true;
        state.error = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.loading.fetchOrderDetails = false;
        state.orderDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.loading.fetchOrderDetails = false;
        state.error = action.payload;
      })
      .addCase(unlinkOrder.pending, (state) => {
        state.loading.unlinkOrder = true;
      })
      .addCase(unlinkOrder.fulfilled, (state, action) => {
        state.loading.unlinkOrder = false;
        state.linkedOrder = action.payload
        // const index = state.data.findIndex(order => order.id === action.meta.arg.orderId);
        // if (index !== -1) state.data.splice(index, 1);
      })
      .addCase(unlinkOrder.rejected, (state, action) => {
        state.loading.unlinkOrder = false;
        state.error = action.payload;
      })
      // Place Order
      .addCase(placeOrder.pending, (state) => {
        state.loading.placeOrder = true;
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.loading.placeOrder = false;
        // Update your state as needed based on the action outcome  For example, updating the specific order's status to 'Placed'
        const index = state.orderData.findIndex(order => order.id === action.meta.arg.orderId);
        if (index !== -1) {
          state.orderData[index] = { ...state.orderData[index], status: 'Placed' }; // Assuming the status field controls the order state
        }
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.loading.placeOrder = false;
        state.error = action.payload;
      })
      // Cancel Order
      .addCase(cancelOrder.pending, (state) => {
        state.loading.cancelOrder = true;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.loading.cancelOrder = false;
        // Update the state based on the action outcome
        // For example, marking the specific order as 'Canceled'
        const index = state.orderData.findIndex(order => order.id === action.meta.arg.orderId);
        if (index !== -1) {
          state.orderData[index] = { ...state.orderData[index], status: 'Canceled', cancelReason: action.meta.arg.cancelReason };
        }
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.loading.cancelOrder = false;
        state.error = action.payload;
      })
      // Update Order Product
      .addCase(updateProduct.pending, (state) => {
        state.loading.updateProduct = true;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.loading.updateProduct = false;
        state.productDetails = action.payload;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.loading.updateProduct = false;
        state.error = action.payload;
      })
      // Delete Order by ID
      .addCase(deleteOrderById.pending, (state) => {
        state.loading.deleteOrderById = true;
        state.error = null;
      })
      .addCase(deleteOrderById.fulfilled, (state) => {
        state.loading.deleteOrderById = false;
        state.error = null;
      })
      .addCase(deleteOrderById.rejected, (state, action) => {
        state.loading.deleteOrderById = false;
        state.error = action.payload;
      })
      // Delete Order Product
      .addCase(deleteOrderProduct.pending, (state) => {
        state.loading.deleteOrderProduct = true;
      })
      .addCase(deleteOrderProduct.fulfilled, (state, action) => {
        state.loading.deleteOrderProduct = false;
        state.error = null;
        // const orderIndex = state.orderData.findIndex(order => order.id === action.payload.orderId);
        // if (orderIndex !== -1) {
        //   const products = state.orderData[orderIndex].products || [];
        //   state.orderData[orderIndex].products = products.filter(product => product.id !== action.payload.productId);
        // }
      })
      .addCase(deleteOrderProduct.rejected, (state, action) => {
        state.loading.deleteOrderProduct = false;
        state.error = action.payload;
      })
      // get UOM
      .addCase(fetchUOMDetails.pending, (state) => {
        state.loading.fetchUOMDetails = true;
      })
      .addCase(fetchUOMDetails.fulfilled, (state, action) => {
        state.loading.fetchUOMDetails = false;
        state.uomDetails = action.payload;
      })
      .addCase(fetchUOMDetails.rejected, (state, action) => {
        state.loading.fetchUOMDetails = false;
        state.error = action.payload;
      })
   
  },
});

// Export actions and reducer
export const { resetOrderState, setOrder } = orderSlice.actions;
export default orderSlice.reducer;
